import { OnInit, Component } from "@angular/core";
import { DatePipe } from "@angular/common";

import { HttpErrorResponse } from "@angular/common/http";
import { NzNotificationService } from "ng-zorro-antd";

import { GlobalComponent, Result, Aziende, Dipendente, Ordine } from "../../environments/global";

@Component({
	selector: "app-ordini-report",
	templateUrl: "ordini.report.html",
	styleUrls: ["ordini.report.scss"],
	providers: [DatePipe],
})
export class OrdiniReportComponent implements OnInit {
	// TABLE VARS
	timesData = [];
	public displayData = [...this.timesData];
	ordersData = [];
	editCache = {};
	sortName = null;
	sortValue = null;
	// COMPONNET VARS
	companyData: Array<string> = Aziende;
	isSpinning: boolean = false;
	isLoading: boolean = false;
	selectedCompany: string;
	selectedOrders = [];
	selectedMonth: Date;
	selectedOrder: Ordine;
	statusFilter: boolean = true;
	totalSwitch: boolean = false;
	currentTotale: string = "Totale ore: 0";
	dateFormat = "dd/MM/yyyy";

	// ################################################
	// CLASS: CONSTRUCTOR
	constructor(public g: GlobalComponent, private datepipe: DatePipe, private notification: NzNotificationService) {
		this.setup();
	}
	// ################################################
	// CLASS: ON INIT
	ngOnInit() {
		this.setup();
		this.loadData();
	}
	setup() {
		// SETUP INTERFACE
		this.g.menuState = 6;
		this.g.homeTitle = "Report Ordini";
	}
	loadData(reSelect: boolean = false) {
		this.isSpinning = true;
		const query: string = "SELECT * from chk_orders WHERE `status`=" + (this.statusFilter ? "1" : "0");
		this.g.mysql(query).subscribe(
			(res: Result) => {
				this.ordersData = res.data;
				this.isSpinning = false;
				if (reSelect) {
					this.selectedOrder = null;
					this.selectOrders();
				}
			},
			(error: HttpErrorResponse) => {
				this.isSpinning = false;
				this.notification.error("Si è vericato un errore non previsto", error.statusText, { nzDuration: 0 });
			}
		);
	}
	selectOrders() {
		if (this.selectedCompany) {
			this.selectedOrders = this.ordersData.filter((o) => o.company === this.selectedCompany);
			this.selectedOrder = null;
		}
	}
	loadTimes() {
		this.isLoading = true;

		// tslint:disable-next-line:max-line-length
		let query: string =
			"SELECT chk_times.id, chk_times.userId, chk_times.date, chk_times.orderId, chk_times.h, chk_users.name, chk_users.surname, chk_orders.status FROM chk_times INNER JOIN chk_users ON chk_users.id = chk_times.userId INNER JOIN chk_orders ON chk_orders.id = chk_times.orderId" +
			" WHERE `orderId`=" +
			this.selectedOrder.id;
		if (this.selectedMonth != null) {
			const startDate = new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth(), 1);
			const endDate = new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth() + 1, 0);
			query +=
				' AND  chk_times.date >= "' +
				this.datepipe.transform(startDate, "yyyy-MM-dd") +
				'"' +
				' AND  chk_times.date <= "' +
				this.datepipe.transform(endDate, "yyyy-MM-dd") +
				'"';
		}

		query += " ORDER BY chk_times.date";

		return this.g.mysql(query).subscribe(
			(res: Result) => {
				this.isLoading = false;
				this.timesData = res.data;

				this.processData();

				let n: number = 0;
				res.data.forEach((t) => {
					n += t.h;
				});
				this.currentTotale = n > 0 ? "Totale ore: " + n : "";
			},
			(error: HttpErrorResponse) => {
				this.isLoading = false;
				this.notification.error("Si è vericato un errore non previsto", error.statusText, {
					nzDuration: this.g.normalTime,
				});
			}
		);
	}
	processData() {
		if (this.totalSwitch) {
			const sum = this.timesData.reduce((acc, cur) => {
				const found = acc.find((val) => val.name === cur.name && val.surname === cur.surname);
				if (found) {
					found.h += cur.h;
					found.date = null;
				} else {
					acc.push({ ...cur, h: cur.h });
				}
				return acc;
			}, []);
			this.displayData = [...sum];
		} else {
			this.displayData = [...this.timesData];
		}
	}
	sort(sort: { key: string; value: string }): void {
		this.sortName = sort.key;
		this.sortValue = sort.value;
		if (this.sortName) {
			this.displayData = [
				...this.timesData.sort((a, b) =>
					this.sortValue === "ascend"
						? a[this.sortName] > b[this.sortName]
							? 1
							: -1
						: b[this.sortName] > a[this.sortName]
						? 1
						: -1
				),
			];
		} else {
			this.displayData = [...this.timesData];
		}
	}
}
